"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrbitalPowerGrid = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var OrbitalPowerGrid = (function (_super) {
    __extends(OrbitalPowerGrid, _super);
    function OrbitalPowerGrid() {
        return _super.call(this, {
            name: CardName_1.CardName.ORBITAL_POWER_GRID,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.SPACE],
            cost: 19,
            metadata: {
                description: 'Increase your energy production 1 step per city tile NOT ON MARS.',
                cardNumber: 'M85',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(1); }).slash().city().any.secondaryTag(Tags_1.Tags.SPACE);
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    ;
    OrbitalPowerGrid.prototype.play = function (player) {
        var amount = player.game.getCitiesInPlay() - player.game.getCitiesInPlayOnMars();
        player.addProduction(Resources_1.Resources.ENERGY, amount, { log: true });
        return undefined;
    };
    OrbitalPowerGrid.prototype.getVictoryPoints = function () {
        return 1;
    };
    return OrbitalPowerGrid;
}(Card_1.Card));
exports.OrbitalPowerGrid = OrbitalPowerGrid;
//# sourceMappingURL=OrbitalPowerGrid.js.map